enum CTAType {
  NONE = 'none',
  IMAGE = 'cta-image',
  BOTTOM_CENTER_BUTTON = 'bottom-center-button',
}

export { CTAType };
